import React, { FC, useContext } from 'react'
import styled from 'styled-components'
import { Fonts, Button } from 'components/base-ui'
import { useTranslation } from 'react-i18next'
import { AppContext } from 'contexts/AppProvider'

interface NoneMemberShipDescProps {
  brandLogo: string
  vendorName: string
  onConnectMembership: () => void
}

const NoneMemberShipDesc: FC<NoneMemberShipDescProps> = ({ onConnectMembership, brandLogo, vendorName }) => {
  const { isThaiLang } = useContext(AppContext)
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Background />
      <Content>
        <Row>
          <Logo src={brandLogo} width="56" />
          <Title>
            <Fonts.H4>{`${t('dineInMemberTitle', { vendorName })}`}</Fonts.H4>
            <Fonts.H4>{`${t('dineInGetBenefit')}`}</Fonts.H4>
          </Title>
        </Row>
        <Row>
          <div style={{ width: 56 }} />
          <ButtonWrapper>
            <ConnectMembershipButton onClick={onConnectMembership} isThaiLang={isThaiLang}>
              {t('dineInConnectMembership')}
            </ConnectMembershipButton>
          </ButtonWrapper>
        </Row>
      </Content>
    </Wrapper>
  )
}

export default NoneMemberShipDesc

const Wrapper = styled.div`
  width: 100%;
  height: 150px;
`

const Background = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    150deg,
    #f88d2a -10%,
    rgba(235, 64, 52, 0.1),
    ${({ theme }) => theme.colors.white},
    rgba(255, 239, 224, 0.1),
    #ffefe0
  );
  border-radius: 16px;
`

const Content = styled.div`
  position: inherit;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 22px;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(0%, -100%);
`

const Logo = styled.img`
  border-radius: 50%;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
`

const Title = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (max-width: 371px) {
    h4 {
      font-size: 13px !important;
    }
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  width: fit-content;

  button {
    max-width: fit-content;
    border-radius: 85px;
    height: 35px;
  }
`
const ConnectMembershipButton = styled(Button)<{ isThaiLang: boolean }>`
  font-size: 15px !important;
  font-weight: bold;
  min-width: ${({ isThaiLang }) => (isThaiLang ? '160px' : '200px')} !important;
`
